(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-home"]) return;
  try {
    
const filter = document.querySelector('#hh-filter');
if (filter) {
  const form = filter.closest('form');
  const cards = Array.from(document.querySelectorAll('[data-hh-search]'));
  const buttons = Array.from(document.querySelectorAll('[data-hh-topic]'));
  const empty = document.querySelector('.hh-empty');
  let topic = 'All';
  document.querySelector('.hh-filterbar').hidden = false;
  function readLocation() {
    const params = new URLSearchParams(location.search);
    filter.value = params.get('q') || '';
    topic = buttons.some(button => button.dataset.hhTopic === params.get('topic')) ? params.get('topic') : 'All';
  }
  function apply(updateLocation) {
    const words = filter.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
    let count = 0;
    for (const card of cards) {
      card.hidden = (topic !== 'All' && card.dataset.hhGroup !== topic) || !words.every(word => card.dataset.hhSearch.toLocaleLowerCase().includes(word));
      if (!card.hidden) count++;
    }
    for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.hhTopic === topic));
    empty.hidden = count !== 0;
    document.querySelector('#hh-search-count').textContent = count + ' / ' + cards.length;
    if (updateLocation) {
      const url = new URL(location.href);
      if (filter.value.trim()) url.searchParams.set('q', filter.value.trim()); else url.searchParams.delete('q');
      if (topic !== 'All') url.searchParams.set('topic', topic); else url.searchParams.delete('topic');
      history.replaceState(null, '', url);
    }
  }
  filter.addEventListener('input', () => apply(true));
  form.addEventListener('submit', event => { event.preventDefault(); apply(true); });
  for (const button of buttons) button.addEventListener('click', () => { topic = button.dataset.hhTopic; apply(true); });
  document.querySelector('#hh-reset').addEventListener('click', () => { filter.value = ''; topic = 'All'; apply(true); filter.focus(); });
  window.addEventListener('popstate', () => { readLocation(); apply(false); });
  window.addEventListener('pageshow', () => { readLocation(); apply(false); });
  readLocation();
  apply(false);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
